import { VStack } from "@/components/Layout";
import { Separator } from "@/components/ui/separator";
import { useDesktopOrMobileMediaQuery } from "@/hooks/useMediaQuery";
import { cn } from "@/lib/cn";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import GlobalHeaderPc from "./_individual/individual/-components/GlobalHeader/GlobalHeaderPc";
import GlobalHeaderSp from "./_individual/individual/-components/GlobalHeader/GlobalHeaderSp";

export const Route = createFileRoute("/_individual")({
  component: IndividualLayout,
});

function IndividualLayout() {
  const { isDesktop } = useDesktopOrMobileMediaQuery();
  return (
    <VStack>
      {isDesktop ? <GlobalHeaderPc /> : <GlobalHeaderSp />}
      <Separator />
      <main className={cn("min-h-screen bg-neutral-fill")}>
        <Outlet />
      </main>
    </VStack>
  );
}
